import React from "react";
import "../../Pages/Items/ManageItem.css";
import "./PlayerProfileTabs.css";

const PlayerProfileInventoryTab = ({
  inventorySearch,
  setInventorySearch,
  filteredInventory,
}) => {
  return (
    <div className="equipment-container profile-inventory all-items-shell">
      <div className="equipment-header all-items-header">
        <h1 className="equipment-title">Inventory</h1>
        <p className="equipment-subtitle">View this player's item collection</p>
      </div>

      <div className="inventory-section profile-inventory__panel all-items-panel">
        <div className="inventory-header profile-inventory__toolbar all-items-toolbar">
          <div className="search-container profile-inventory__search all-items-search">
            <input
              type="text"
              className="search-input"
              placeholder="Search items..."
              value={inventorySearch}
              onChange={(e) => setInventorySearch(e.target.value)}
            />
            <div className="search-icon">
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <circle cx="11" cy="11" r="8"></circle>
                <path d="21 21l-4.35-4.35"></path>
              </svg>
            </div>
          </div>
        </div>

        <div className="inventory-grid profile-inventory__grid all-items-grid">
          {filteredInventory
            .filter((item) => item.amount > 0)
            .map((item) => (
              <div key={item.item} className="inventory-item profile-inventory__card all-items-card">
                <img
                  src={`${item.item_image}`}
                  alt={item.item_name}
                  className="inventory-item-image"
                />
                <div className="inventory-item-name all-items-name">{item.item_name}</div>
                <div className="inventory-item-quantity all-items-qty">
                  {Number(item.amount).toLocaleString()}
                </div>
              </div>
            ))}
        </div>

        {filteredInventory.filter((item) => item.amount > 0).length === 0 && (
          <div className="profile-inventory__empty">
            <p>No items found</p>
          </div>
        )}
      </div>
    </div>
  );
};

export default PlayerProfileInventoryTab;
